import Slider from "react-slick"
import { Link } from "gatsby"

import { Img } from "../../../layout/Img"

const CaseStudy = ({
  title,
  coverPicture,
  caseStudyCategories,
  caseStudyProgramsAndProducts,
  sponsor,
  uri,
}) => {
  const [pic] = coverPicture
  return (
    <div className="mx-4 xl:mx-14 lg:mx-10">
      <div className="items-center group lg:flex bg-bgcard">
        {/* aspect-w-6 aspect-h-4 md:aspect-w-12 md:aspect-h-4 */}
        <div className="mx-auto lg:w-6/12">
          <Img className="h-96" image={pic} alt={pic?.title} />
        </div>
        <div className="flex flex-col items-start p-6 lg:w-6/12 lg:px-16 xl:px-16">
          <span className="px-2 py-1 text-xs uppercase border-2 rounded-full 2xl:text-sm text-secondary border-highlightColor">
            {caseStudyCategories[0]?.title}
          </span>
          <div className="h-52 md:h-36">
            <h3 className="mt-5 text-2xl font-semibold normal-case text-secondary xl:text-3xl">
              {title}
            </h3>
            <p className="mt-5">
              <span className="font-light xl:text-lg">
                <b>Program: </b>{caseStudyProgramsAndProducts[0]?.title}
                <br>
                </br>
                <b>Partner: </b>{sponsor[0]?.title}
              </span>
            </p>
          </div>
          <div className="flex gap-2 my-4 cursor-pointer lg:mt-20 lg:mb-2">
            <Link to={`/${uri}`}>
              <span className="p-3 text-sm font-normal text-white rounded bg-pink hover:shadow-md">
                View Case Study
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export const FeaturedCaseStudies = ({ caseStudies }) => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 12000,
    speed: 800,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
        },
      },
    ],
  }

  return (
    <div className="container flex flex-col items-center justify-center mx-auto mb-12 lg:w-10/12">
      <Slider className="w-full customSlick" {...settings}>
        {caseStudies.map(({ uid, ...rest }) => (
          <CaseStudy key={uid} {...rest} />
        ))}
      </Slider>
    </div>
  )
}
